import { Card, Grid } from '@scuf/common';
import { LabelDescription } from 'components';
import { dateFormatFromMicrosft } from 'helpers';
import { MicroSigaInvcoiceDTO } from 'models/spareParts/orderById';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
type Props = {
    invoice: MicroSigaInvcoiceDTO;
};
const BillingTile: React.FC<Props> = ({ invoice }: Props) => {
    const { t } = useTranslation(['spareparts', 'common']);
    const details = ['CurrierName', 'TrackingCode'];
    const [isModalOpen, setModalOpen] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const handleDelete = (): void => {
        setLoading(true);
    };
    return (
        <Card>
            <Card.Header title={`${t('common:translation.Note')} #${invoice.invoiceNumber}`}>
                {/* <Button
                    size="small"
                    icon={<Icon name="delete" color="white" size="medium" />}
                    content={t("Delete")}
                    loading={loading}
                    onClick={() => setModalOpen(true)}
                ></Button> */}
            </Card.Header>
            <Card.Content>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={4}>
                            <LabelDescription
                                title={t('Issued')}
                                value={dateFormatFromMicrosft(invoice.issued) ?? t('common:status.NotInformed')}
                            ></LabelDescription>
                        </Grid.Column>
                        {details.map((e: string, index) => (
                            <Grid.Column key={e} width={4}>
                                <LabelDescription
                                    title={t(e)}
                                    value={invoice[e as keyof typeof invoice] ?? t('common:status.NotInformed')}
                                ></LabelDescription>
                            </Grid.Column>
                        ))}
                    </Grid.Row>
                </Grid>
            </Card.Content>
            {/* <DeleteInvoiceModal
                open={isModalOpen}
                onclose={() => setModalOpen(false)}
                onconfirm={() => handleDelete()}
                noteNumber="0"
            ></DeleteInvoiceModal> */}
        </Card>
    );
};

export default BillingTile;
